import { useEffect, useState, useCallback } from "react";
import useMutationObserver from "@rooks/use-mutation-observer";
import useOnWindowScroll from "@rooks/use-on-window-scroll";
/**
 * @param element HTML element whose boundingclientrect is needed
 * @returns ClientRect
 */
function getBoundingClientRect(element) {
    return element.getBoundingClientRect();
}
/**
 * useBoundingclientRect hook
 *
 * @param ref The React ref whose ClientRect is needed
 * @returns ClientRect
 */
function useBoundingclientrect(ref) {
    var _a = useState(null), value = _a[0], setValue = _a[1];
    var update = useCallback(function () {
        setValue(ref.current ? getBoundingClientRect(ref.current) : null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        update();
    }, [update]);
    useMutationObserver(ref, update);
    useOnWindowScroll(update);
    return value;
}
export { useBoundingclientrect };
//# sourceMappingURL=useBoundingclientrect.js.map